/**
 * Extracts the stock sub-path (silos or materials) from the relative path or full pathname.
 * Works with both HCEM (full pathname) and Suite (relative path from wildcard route).
 *
 * @param pathOrRelativePath - Either a wildcard relative path (e.g., 'silos') or full pathname (e.g., '/plants/abc/stock/silos')
 * @returns 'silos' | 'materials' | undefined
 */
export const getStockSubPath = (pathOrRelativePath: string): 'silos' | 'materials' | undefined => {
  // Handle both '/silos', 'silos', and '/plants/abc/stock/silos' formats
  const segments = pathOrRelativePath.split('/').filter(Boolean)

  // Check if any segment matches silos or materials
  for (const segment of segments) {
    if (segment === 'silos' || segment === 'materials') {
      return segment
    }
  }

  return undefined
}
